import { render, staticRenderFns } from "./CustomerOrderTypeAvailabilities.vue?vue&type=template&id=1224c97a&"
import script from "./CustomerOrderTypeAvailabilities.vue?vue&type=script&lang=js&"
export * from "./CustomerOrderTypeAvailabilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports